import { PartQohLocationsLookup } from './PartQohLocationsLookup';
import { DieNumberLookup } from './DieNumberLookup';
import { LumberScheduleLookup } from './LumberScheduleLookup';
import { LumberPartLookup } from './LumberPartLookup';
import { PutDownMillLookup } from './PutDownMillLookup';
/**
 * Render the request.dynamicInputResult based on request.action.actionQuery type
 * @param {Local.DynamicActionInputResultProps} props
 */
export const DynamicActionInputResult = ({ request }) => {
  switch (request.action.actionQuery) {
    case 'PART_QOH_LOCATIONS_LOOKUP': {
      const partQohRequest = /** @type {Local.PartQohLookupRequest} */ (request);
      return <PartQohLocationsLookup results={partQohRequest.dynamicInputResult} />;
    }
    case 'DIE_NUMBER_LOOKUP': {
      const dieNumberRequest = /** @type {Local.DieNumberLookupRequest} */ (request);
      return <DieNumberLookup result={dieNumberRequest.dynamicInputResult} />;
    }
    case 'LUMBER_SCHEDULE_LOOKUP': {
      const lumberScheduleRequest = /** @type {Local.LumberScheduleLookupRequest} */ (request);
      return <LumberScheduleLookup result={lumberScheduleRequest.dynamicInputResult} />;
    }
    case 'LUMBER_PART_LOOKUP': {
      const lumberPartRequest = /** @type {Local.LumberPartLookupRequest} */ (request);
      return <LumberPartLookup result={lumberPartRequest.dynamicInputResult} />;
    }
    case 'P10_PUT_DOWN_MILL': {
      const putDownMillRequest = /** @type {Local.PutDownMillLookupRequest} */ (request);
      return <PutDownMillLookup result={putDownMillRequest.dynamicInputResult} />;
    }
    case 'PART_DESCRIPTION_LOOKUP': {
      const partDescriptionRequest = /** @type {Local.PartDescriptionLookupRequest} */ (request);
      return (
        <span data-testid='dynamic-input-result'>
          {partDescriptionRequest.dynamicInputResult?.description || 'No description found'}
        </span>
      );
    }
    default:
      return null;
  }
};
